import { CACHE_EXCHANGE_PAIRS } from "../actions/types";

const initialState = {
  exchangePairs: {},
};

const cacheReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CACHE_EXCHANGE_PAIRS:
      return {
        ...state,
        exchangePairs: {
          ...state.exchangePairs,
          [payload.exchangeId]: payload.data,
        },
      };
    default:
      return state;
  }
};

export default cacheReducer;
